module.exports = __webpack_public_path__ + "static/media/image_8.37cf549c.png";